/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Images_HintInputs */

const cs_property_ai_images_hint = /** @type {(inputs: Property_Ai_Images_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vylepšete nebo nastagujte fotku — výsledek se přidá do galerie (publikováno). První fotka v galerii je cover.`)
};

const en_property_ai_images_hint = /** @type {(inputs: Property_Ai_Images_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enhance or stage a photo — the result is added to the gallery (published). First gallery photo is the cover.`)
};

/**
* | output |
* | --- |
* | "Enhance or stage a photo — the result is added to the gallery (published). First gallery photo is the cover." |
*
* @param {Property_Ai_Images_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_images_hint = /** @type {((inputs?: Property_Ai_Images_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Images_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_images_hint(inputs)
	return cs_property_ai_images_hint(inputs)
});